/*
 *             Copyright (c) 2016 - 2022, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
'use strict';var __importDefault=this&&this['__importDefault']||function(_0x1c3259){return _0x1c3259&&_0x1c3259['__esModule']?_0x1c3259:{'default':_0x1c3259};};Object['defineProperty'](exports,'__esModule',{'value':!0x0});const ckeditorcloudserviceserror_1=__importDefault(require('../ckeditorcloudserviceserror'));class ServiceNotConnectedError extends ckeditorcloudserviceserror_1['default']{constructor(_0x5620c8,_0x39ee41){super(_0x5620c8+'\x20Service\x20is\x20not\x20connected.',_0x39ee41);}}exports['default']=ServiceNotConnectedError;